// Reading a query again once for a burst of events.
//
// Promise:
// - The first event of a burst puts the read off `SETTLE_MS`; the events that
//   come meanwhile join it. The read starts after the last of them arrived, so
//   it sees what each of them changed.
// - Pending reads are kept per app (its query client) and per key, never for
//   the module.
import type {
  InvalidateQueryFilters,
  QueryClient,
} from "@tanstack/react-query";

/** How long a read waits for more events of the same burst. */
export const SETTLE_MS = 200;

const pending = new WeakMap<QueryClient, Set<string>>();

export function invalidateAfterBurst(
  qc: QueryClient,
  filters: InvalidateQueryFilters & { queryKey: readonly unknown[] },
) {
  const id = JSON.stringify(filters.queryKey);
  const keys = pending.get(qc) ?? new Set<string>();
  pending.set(qc, keys);
  if (keys.has(id)) return;
  keys.add(id);
  setTimeout(() => {
    keys.delete(id);
    void qc.invalidateQueries(filters);
  }, SETTLE_MS);
}
